import moment from 'moment';
import * as R from 'ramda';

const library = require('@safe-systems/ss-ui-components');

const { copy } = library;

export default function GenerateReportsDialogController(
  $q,
  $filter,
  reportsDataService,
  loaderService,
  alerts,
  ssDialogService,
) {
  const vm = this;

  vm.reportsExpanded = false;

  vm.doArchive = false;
  vm.disableSubmit = true;
  vm.lastSelectedReportId = -1;

  vm.showFilters = true;

  vm.report = {};

  vm.archiveTooltip = '';

  vm.filteredReports = vm.reports;
  vm.filter = {
    selectedFocus: '-1',
  };
  vm.filter.focuses = [];

  vm.handleCloseDialogClick = handleCloseDialogClick;
  vm.handleSelectReportClick = handleSelectReportClick;
  vm.handleRunReportFormSubmit = handleRunReportFormSubmit;
  vm.handleParameterChange = handleParameterChange;
  vm.handleToggleFilters = handleToggleFilters;
  vm.handleFilterJobs = handleFilterJobs;

  _activate();

  /** ********************************************
   * Event Handlers
   */
  function _activate() {
    R.forEach(report => {
      initializeDefaultParameters(report);

      if (report.reportGroups[0].focus !== null) {
        const listItem = {
          id: report.reportGroups[0].focus,
          name: report.reportGroups[0].focus,
          value: true,
        };

        const items = $filter('filter')(vm.filter.focuses, { id: listItem.id });

        if (items.length === 0) {
          vm.filter.focuses.push(listItem);
        }
      }

      if (vm.archiveTooltip === '') {
        if (report.reportGroups[0].family !== null) {
          vm.archiveTooltip =
            'If "Save to Financial Institution Reports" is selected, the generated report will be saved to the ' +
            report.reportGroups[0].family.name +
            ' section of the Financial Institution Reports page for later access.';
        } else {
          vm.archiveTooltip =
            'If "Save to Financial Institution Reports" is selected, the generated report will be saved to the Compliance section of the Financial Institution Reports page for later access.';
        }
      }
    }, vm.reports);

    vm.filter.focuses = R.sortBy(R.prop('name'), vm.filter.focuses);
    vm.filter.focusCount = vm.filter.focuses.length;
  }

  function initializeDefaultParameters(report) {
    if (report.reportParameters !== null && report.reportParameters !== undefined) {
      report.reportParameters.forEach(parameter => {        
        // Numeric
        if (parameter.parameterDataType === 'numeric') {
          vm.report[`parameter${parameter.parameterId}Value`] = Number(parameter.defaultValue);
        }
      });
    }
  }

  function handleCloseDialogClick() {
    _closeDialog();
  }

  function handleSelectReportClick(report) {
    vm.selectedReportId = report.reportId;
    vm.selectedReport = report;

    if (vm.report.renderFormat === undefined || vm.report.renderFormat === null) {
      vm.report.renderFormat = report.renderFormat;
    }

    // Make changes to the selection criteria because the selected report changed.
    if (vm.lastSelectedReportId != vm.selectedReportId) {
      vm.report.renderFormat = report.renderFormat;
      vm.lastSelectedReportId = vm.selectedReportId;
    }
  }

  // Run Report
  function handleRunReportFormSubmit($event) {
    $event.stopPropagation();
    const report = R.find(R.propEq('reportId', vm.selectedReportId), vm.reports);
    const reportParameters = _getReportParametersFromUI(report);

    _runReport(report.reportId, vm.report.renderFormat, reportParameters).then(() => {
      loaderService.showViewLoader = false;
    });
  }

  function handleParameterChange(parameter) {
    const report = R.find(R.propEq('reportId', vm.selectedReportId), vm.reports);
    const value = _getUserValue(parameter);

    if (report.reportParameters !== null && report.reportParameters !== undefined) {
      const paramsToUpdate = R.find(R.propEq('dependantUponId', parameter.parameterId), report.reportParameters);

      if (paramsToUpdate !== null && paramsToUpdate !== undefined) {
        loaderService.showViewLoader = true;
        reportsDataService
          .getDependantValues(parameter.reportGroupId, paramsToUpdate.parameterId, value)
          .then(response => {
            const retParam = response.data;
            report.reportParameters.forEach(param => {
              if (param.parameterId === retParam.parameterId) {
                param.reportParameterValues = retParam.reportParameterValues;
                param.userValue = '';
                const selectedValuesObj = vm.report;
                if (selectedValuesObj !== null && selectedValuesObj !== undefined) {
                  const paramSelectedValuesObj = vm.report[`parameter${param.parameterId}Value`];
                  if (paramSelectedValuesObj !== null && paramSelectedValuesObj !== undefined) {
                    vm.report[`parameter${param.parameterId}Value`] = '';
                  }
                }
              }
            });
            loaderService.showViewLoader = false;
          });
      }
    }
  }

  function handleToggleFilters() {
    vm.showFilters = !vm.showFilters;
  }

  function handleFilterJobs() {
    // Focuses
    let selectedFocusCount = 0;
    let allFocusesSelected = false;
    let noFocusesSelected = false;

    R.forEach(focus => {
      if (focus.value) {
        selectedFocusCount++;
      }
    }, vm.filter.focuses);

    if (selectedFocusCount === vm.filter.focuses.length) {
      allFocusesSelected = true;
    } else if (selectedFocusCount === 0) {
      noFocusesSelected = true;
    }

    if (allFocusesSelected) {
      vm.filteredReports = vm.reports;
    } else if (noFocusesSelected) {
      vm.filteredReports = [];
    } else {
      let tempReports = vm.reports;
      let tempFilteredReports = [];

      R.forEach(focus => {
        if (!focus.value) {
          R.forEach(report => {
            if (report.reportGroups[0].focus !== focus.name) {
              tempFilteredReports.push(report);
            }
          }, tempReports);

          tempReports = tempFilteredReports;
        }
      }, vm.filter.focuses);

      vm.filteredReports = tempReports;
    }
  }

  /** ********************************************
   * Private Functions
   */

  function _getReportParametersFromUI(report) {
    const uiReportParameters = report.reportParameters;
    const hasNoSubmittedParameters = R.isEmpty(uiReportParameters) || R.isNil(uiReportParameters);

    if (hasNoSubmittedParameters) {
      return uiReportParameters;
    }

    uiReportParameters.forEach(param => {
      if (param.parameterName === 'ATCustID') {
        param.userValue = vm.atCustId;
      }
    });

    return R.map(
      parameter => ({
        parameterName: parameter.parameterName,
        parameterValue: _getUserValue(parameter),
      }),
      uiReportParameters,
    );
  }

  function _getUserValue(parameter) {
    if (parameter.parameterDataType === 'int') {
      let retVal = null;
      if (parameter.userValue !== undefined) {
        retVal = parameter.userValue;
      }
      return retVal;
    }

    // Dropdown
    if (parameter.parameterDataType === 'varchar') {
      let retVal = null;
      if (parameter.userValue !== undefined) {
        retVal = parameter.userValue;
      }
      return retVal;
    }

    // DateTime
    if (parameter.parameterDataType === 'datetime') {
      let retVal = null;
      if (parameter.userValue !== undefined) {
        retVal = moment(parameter.userValue).format('MM/DD/YYYY');
      }
      return retVal;
    }

    // Multiselect
    if (parameter.parameterDataType === 'multiselect') {
      const values = vm.report[`parameter${parameter.parameterId}Value`];
      if (values.includes('All') === true) {
        return 'All';
      }
      return values.join();
    }

    // Numeric
    if (parameter.parameterDataType === 'numeric') {
      let retVal = null;
      const value = vm.report[`parameter${parameter.parameterId}Value`];
      if (value !== undefined) {
        retVal = value;
      }
      return retVal;
    }

    return parameter.userValue;
  }

  function _runReport(reportId, renderFormat, parameters) {
    const dfdReturn = $q.defer();

    if (vm.doArchive) {
      alerts.success(copy.global.appReports.alerts.archivingReport.text);
    } else {
      alerts.success(copy.global.appReports.alerts.generatingReport.text);
    }

    if (vm.serviceId > 0) {
      reportsDataService
        .viewAppReport(vm.serviceId, reportId, renderFormat, parameters, vm.doArchive)
        .then(serviceReportResponse => {
          alerts.success('Your report is ready.');
          if (vm.saveType === 'viewReport') {
            reportsDataService.viewReportBlob(serviceReportResponse);
          } else {
            reportsDataService.download(serviceReportResponse);
          }
          dfdReturn.resolve();
        });
    } else if (vm.selectedReportId && vm.groupId) {
      reportsDataService
        .viewAppReportByGroup(vm.groupId, reportId, renderFormat, parameters, vm.doArchive)
        .then(groupReportResponse => {
          alerts.success('Your report is ready.');
          if (vm.saveType === 'viewReport') {
            reportsDataService.viewReportBlob(groupReportResponse);
          } else {
            reportsDataService.download(groupReportResponse);
          }
          dfdReturn.resolve();
        });
    }

    return dfdReturn.promise;
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.global.generateAppReportsDialog);
  }
}

GenerateReportsDialogController.$inject = [
  '$q',
  '$filter',
  'reportsDataService',
  'loaderService',
  'alerts',
  'ssDialogService',
];
